var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.config.name,_vm._b({key:_vm.config.name,ref:"form",tag:"component",attrs:{"showMobile":_vm.showMobile,"mode":_vm.mode,"perm":_vm.config.perm || _vm.perm,"formData":_vm.formData,"forms":_vm.forms},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}},'component',_vm.config.props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }